import { HttpService } from '@src/api/common/HttpService';
import { CTE_API_URL } from '@src/constants/BaseUrls';

type ImpersonateRequestType = {
  targetRoleId: number | undefined;
  reason?: string;
};

export const ImpersonationService = () => {
  const { HttpGet, HttpPost } = HttpService();

  const GetRoles = async () => {
    const url = `${CTE_API_URL}/api/v1/user-role`;
    const response = await HttpGet(url);
    return response;
  };

  const Impersonate = async (body: ImpersonateRequestType, showLoader: boolean = false) => {
    const url = `${CTE_API_URL}/api/v1/admin/impersonate`;
    const response = await HttpPost(url, body, showLoader);
    return response;
  };

  return {
    GetRoles,
    Impersonate,
  };
};
